/**
 * Dismissal side of the branded boot splash.
 *
 * The splash itself is written during HTML parse into #splash — a sibling of
 * #root, see public/index.html. React mounts underneath it and never re-creates
 * it, which is what guarantees the pre-React and post-React loading screens are
 * identical: they are the same DOM node.
 *
 * The actual fade-and-remove lives inline in index.html (window.__stylonDismissSplash)
 * so it exists at frame one and its 8s safety timeout still fires if the JS
 * bundle never loads. This module is just the bundle-side entry point, with a
 * DOM fallback for tests and for any page served without the inline script.
 */

/** Fade out and remove the splash. Idempotent; safe when there is no splash. */
export function dismissSplash() {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  if (typeof window.__stylonDismissSplash === "function") {
    window.__stylonDismissSplash();
    return;
  }

  const el = document.getElementById("splash");
  if (!el || el.dataset.dismissing === "1") return;
  el.dataset.dismissing = "1";
  el.classList.add("sp-out");
  window.setTimeout(() => {
    if (el.parentNode) el.parentNode.removeChild(el);
  }, 520); // must outlast the 440ms exit choreography in index.html
}

/** True when a splash is currently on screen (and not already going away). */
export function hasSplash() {
  if (typeof document === "undefined") return false;
  const el = document.getElementById("splash");
  return Boolean(el && el.dataset.dismissing !== "1" && el.childNodes.length > 0);
}
